import React, { PureComponent } from "react";
import ContainerDimensions from "react-container-dimensions";
import styled from "styled-components";
import { CSS_CLASS_PREFIX } from "../constants/css";
import { cssMainSelector } from "../lib/cssSelectors";
import PropTypes from "prop-types";
import { media } from "../constants/theme";

// Usage:
//
// import React, { PureComponent } from "react";
// import MediaContainer, { MediaSize } from "../MediaContainer";
// import styled from "styled-components";
//
// const Foo = styled.div`
//   border: 1px blue solid;
//   padding: 10px;
//   ${MediaSize}.sm-up & {
//     border-color: red;
//     padding: 20px;
//   }
// `
// const Bar = styled.div`
//   color: blue;
//   ${MediaSize}.md-up &{
//     color: red;
//   }
// `
//
// class FooBar extends PureComponent {
//   render() {
//     return (
//       <MediaContainer>
//         <Foo>
//           <Bar>I'm a FooBar</Bar>
//         </Foo>
//       </MediaContainer>
//     )
//   }
// }

const defaultWidth = 1024;

const MediaSize = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    position: relative;
  }
`;

class MediaContainer extends PureComponent {
  render() {
    // we need to disable ContainerDimensions for test, it doesn't work with Storyshots
    if (process.env.NODE_ENV === "test") {
      return (
        <MediaSize className={this.mediaClassNames(defaultWidth)}>
          {this.props.children}
        </MediaSize>
      );
    } else {
      return (
        <ContainerDimensions>
          {({ width }) => (
            <MediaSize className={this.mediaClassNames(width)}>
              {this.props.children}
            </MediaSize>
          )}
        </ContainerDimensions>
      );
    }
  }

  mediaClassNames(width) {
    const { outer } = this.props;
    const sizes = Object.keys(media);

    for (let i = 0; i < sizes.length; i++) {
      let key = sizes[i];

      if (width <= media[key]) {
        const largerSizes = sizes.filter(
          size => sizes.indexOf(size) >= i && sizes.indexOf(size) < sizes.length
        );

        let outerLargerSizes = [];
        if (outer) {
          outerLargerSizes = largerSizes;
        }

        const classNames = [].concat(
          largerSizes.map(size => `${CSS_CLASS_PREFIX}-${size}-down`),
          outerLargerSizes.map(size => `${CSS_CLASS_PREFIX}-outer-${size}-down`)
        );

        return classNames.join(" ");
      }
    }
  }
}

MediaContainer.propTypes = {
  outer: PropTypes.bool
};

export default MediaContainer;
